import type { Article } from 'types/capi/article';
import type { User } from 'types/User';

import {
  getEntrypoint,
  getPreviousPagePath,
  getPreviousPageType,
  getSourceAndMedium
} from '~/utils/navigationContext';

import UserEvent from './UserEvent';

type EventData = {
  article: Article;
  clientIp?: string;
  isBot: boolean;
  user: User;
};

class ArticleViewEvent extends UserEvent<EventData> {
  collectServerEvents() {
    const { article } = this.data;

    this.serverEvents.push({
      data: {
        article_id: article.id,
        article_title: article.title,
        article_type:
          'article_type' in article ? article.article_type : undefined,
        client_ip: this.data.clientIp,
        is_logged_in: this.data.user.isLoggedIn,
        useragent: navigator.userAgent,
        ...this.getSharedParams()
      },
      type: 'article_view'
    });
  }

  private getSharedParams() {
    return {
      entry_point: getEntrypoint(),
      page_path: window.location.pathname,
      page_type: 'article' as const,
      platform: 'web' as const,
      previous_page_path: getPreviousPagePath(),
      previous_page_type: getPreviousPageType(),
      source_medium: getSourceAndMedium()
    };
  }
}

export default ArticleViewEvent;
